import { BasketItem } from '@df/session/api/basket/basket-item';

export class GiftboxAssignment {
    /**
     * Class constructor
     * @param {BasketItem} public    item Product (not box) that can be placed in box
     * @param {number}     protected piece, Assignment is per piece not per item, this here is piece numebr
     */
    public constructor(
        public item: BasketItem,
        protected piece: number,
        protected _box?: number | 'new' // box item id
    ) {}

    /**
     * Unique assigment id getter
     * @return {string}
     */
    public get id(): string {
        return this.item.id + '.' + this.piece;
    }

    /**
     * Product getter
     */
    public get product() {
        return this.item.product;
    }

    /**
     * Retursns selected box id
     * @return {number} [description]
     */
    public get box(): number | 'new' | undefined {
        return this._box;
    }

    public set box(box: number | 'new' | undefined) {
        this._box = box;
    }
}
